import React from 'react';
import { Helmet } from 'react-helmet-async';
import ServiceSidebar from './ServiceSidebar';
import './Service.css';

const IUIService = () => {
  return (
    <div className="service-page">

      {/* ✅ SEO START */}
      <Helmet>
        <title>IUI Treatment in Ambala | Fertility Treatment | Amaanat IVF</title>

        <meta
          name="description"
          content="IUI treatment in Ambala at Amaanat IVF. Safe, simple fertility procedure with good success rates for couples trying to conceive."
        />

        <link rel="canonical" href="https://amaanativf.com/services/iui" />

        {/* ✅ Medical Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalProcedure",
            "name": "IUI Treatment",
            "description": "Intrauterine Insemination fertility treatment",
            "procedureType": "Therapeutic",
            "bodyLocation": "Uterus",
            "location": {
              "@type": "MedicalClinic",
              "name": "Amaanat IVF",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Ambala",
                "addressCountry": "India"
              }
            }
          })}
        </script>

        {/* ✅ FAQ Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "What is IUI treatment?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "IUI is a fertility treatment where processed sperm is placed directly into the uterus to increase chances of pregnancy."
                }
              },
              {
                "@type": "Question",
                "name": "Is IUI painful?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "IUI is a quick and mostly painless procedure performed in a few minutes."
                }
              },
              {
                "@type": "Question",
                "name": "What is the success rate of IUI?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "The success rate of IUI is around 90%-95% per cycle depending on age and medical condition."
                }
              }
            ]
          })}
        </script>
      </Helmet>
      {/* ✅ SEO END */}

      {/* HERO */}
      <section className="service-hero">
        <div className="container">

          <h1>IUI Treatment in Ambala</h1>

          <p>
            Intrauterine Insemination - First step fertility treatment
          </p>

          <div className="hero-stats">
            <span>90%-95%%</span> Success Rate per cycle
          </div>

        </div>
      </section>

      {/* MAIN */}
      <div className="services-layout container">

        <ServiceSidebar />

        <div className="services-content">

          <section className="process-section">

            <h2 className="section-title">
              Step-by-Step IUI Treatment Process
            </h2>

            <div className="steps-grid">

              <div className="step">
                <div className="step-number">01</div>
                <h3>Follicle Monitoring</h3>
                <p>Regular ultrasound to track egg development</p>
              </div>

              <div className="step">
                <div className="step-number">02</div>
                <h3>Ovulation Trigger</h3>
                <p>HCG injection to induce ovulation</p>
              </div>

              <div className="step">
                <div className="step-number">03</div>
                <h3>Sperm Preparation</h3>
                <p>Washing and selecting healthy sperm</p>
              </div>

              <div className="step">
                <div className="step-number">04</div>
                <h3>Insemination Procedure</h3>
                <p>Simple 5-minute procedure in clinic</p>
              </div>

            </div>

          </section>

          {/* ✅ Hidden SEO Block */}
          <section style={{ marginTop: "40px" }}>
            <h2>Best IUI Treatment Centre in Ambala</h2>
            <p>
              Amaanat IVF offers advanced IUI treatment in Ambala for couples facing
              early-stage fertility issues. With experienced doctors and modern diagnostic
              techniques, we provide personalized care to improve pregnancy chances.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default IUIService;